import React, { DetailedHTMLProps, forwardRef, HTMLAttributes, PropsWithChildren } from "react";

import { hotjarAttr, IHotjarProps, ITestable, testAttr } from "@/browser";

import { withFlex } from "./withFlex";

type HTMLDivElementProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

interface Props extends HTMLDivElementProps, ITestable, IHotjarProps {}

const FlexComponent = forwardRef<HTMLDivElement, PropsWithChildren<Props>>((props, ref) => {
  const { hjSuppress, testName, testValue, ...rest } = props;

  return <div ref={ref} {...testAttr({ testName, testValue })} {...hotjarAttr({ hjSuppress })} {...rest} />;
});

/**
 * @deprecated Use iris-based implementation instead.
 */
export const Flex = withFlex(FlexComponent);
export default Flex;
